// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1Ir3b","filesListContainer":"PosDisputesFiles_filesListContainer__3X7Ax","filesButton":"PosDisputesFiles_filesButton__2fkNo"};